import React, {useState, useEffect, useContext} from "react"
import styled from "styled-components"
import SearchWidget from "./SearchWidget"
import LazyLoad from "react-lazyload"
import { convertImgSrc } from "../functions"
import Skeleton from "react-loading-skeleton"
import BannerV3 from "./BannerV3"
import BannerV2 from "./BannerV2"
import ErrorBoundary from "./ErrorBoundary"
import { GlobalContext } from "../functions"
import _ from "lodash"
import Theme from "@airasia/phoenix-components/components/Theme"

// const SearchWidget = React.lazy(() => import('./SearchWidget'));

var ContainerHeader = styled.div`
  width: 100%;
  height: 450px;
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),
    url(${props => props.img});
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: bottom;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
`
var ContainerSearch = styled.div`
  width: 85%;
  position: relative;
`
var SearchTitle = styled.h1`
  color: #ffffff;
  padding: 0px;
  margin: 0.5rem;
  text-align: center;
  color: #fff;
  text-shadow: 2px 2px #1d1d1d;
  font-size: 3rem;
  font-weight: 500;
  text-align: center;
  @media screen and (max-width: 600px) {
    font-size: 2.5rem;
    display: none;
  }
`

export default function Header(props) {
  let isMobile = false
  if (props.device) {
    isMobile = props.device !== "desktop" ? true : false
  }

  const globalState = useContext(GlobalContext)

  const [currency, setCurrency] = useState(()=>{
    let temp = _.get(globalState, "state.currency", "MYR");
    return temp
  });

  useEffect(()=>{
    console.log("changing the currency from useEffect --- ", _.get(globalState, "state.currency", ""));
    // dispat
    setCurrency(()=>{
      let temp = _.get(globalState, "state.currency", "MYR");
      return temp
    })
  }, [globalState])

  if (props?.bannerType2) {
    return (
      <Theme theme={props.theme}>
      <ErrorBoundary>
        <BannerV3
          image={convertImgSrc(props.image)}
          title={props.title}
          isMobile={isMobile}
          currentRoute={props.currentRoute}
          lang={props.lang}
          currency={currency}
          bannerType2
          template={props.template}
          theme={props.theme}
          url={props.url}
          heroImages={_.get(props, 'heroImages')}
          posCountry={_.get(props, 'posCountry')}
        />
      </ErrorBoundary>
      </Theme>
    )
  }


  return (
    <Theme theme={props.theme}>
      <ErrorBoundary>
        <BannerV2
          image={convertImgSrc(props.image)}
          title={props.title}
          isMobile={isMobile}
          currentRoute={props.currentRoute}
          lang={props.lang}
          currency={currency}
          bannerType2={false}
          template={props.template}
          theme={props.theme}
        /> 
      </ErrorBoundary>
    </Theme>

    // OLD BANNER BELOW
    // <ContainerHeader img={convertImgSrc(props.image)}>
    //   <ContainerSearch>
    //     <SearchTitle>{props.title}</SearchTitle>
    //     <LazyLoad
    //       height={200}
    //       placeholder={
    //         <div style={{ margin: "auto" }}>
    //           <Skeleton />
    //         </div>
    //       }
    //     >
    //       {/* <SearchWidget api={props.api} /> */}
    //       <Store>
    //         <FlightSearchWidget currency="MYR" environment="PRODUCTION"/>
    //       </Store>
    //     </LazyLoad>
    //   </ContainerSearch>
    // </ContainerHeader>
  )
}
